import StereotypeClient from '@cimpress-technology/stereotype-client';
import { Base64 } from "js-base64";
const xStereotypeRelBlacklist = 'https://fulfillment.at.cimpress.io/rels/jobsheet,https://fulfillment.at.cimpress.io/rels/document,https://fulfillment.at.cimpress.io/rels/notifications';
const xStereotypeAcceptPreference = 'image/*;q=0.1,application/json;q=0.9';
export const getTemplate = (accessToken, templateUrl) => {
    const client = new StereotypeClient('Bearer ' + accessToken);
    return client.getTemplate(templateUrl, true, true);
};
export const listTemplates = (accessToken, templateTypes, templateMetadata) => {
    const client = new StereotypeClient('Bearer ' + accessToken);
    return client.listTemplates(true, true, templateTypes)
        .then(userTemplates => templateMetadata && templateMetadata.length > 0 ?
        userTemplates.filter(template => (template.metadata || []).some(meta => templateMetadata.some(item => item.key === meta.key && (item.value && item.value.length > 0 ? item.value.includes(meta.value) : true))))
        : userTemplates);
};
export const cloneTemplate = (accessToken, fromTemplateUrl, templateName) => {
    const client = new StereotypeClient('Bearer ' + accessToken);
    return client.getTemplate(fromTemplateUrl, true, false)
        .then((template) => {
        return createTemplate(accessToken, template.contentType, templateName, Base64.decode(template.templateBody), template.templateType);
    })
        .catch((error) => {
        if (error.response && error.response.status === 404) {
            return Promise.reject(`Template ${fromTemplateUrl} does not exist!`);
        }
    });
};
const createTemplate = (accessToken, contentType, templateName, templateBody = '', templateType = null, templateDescription = null) => {
    const client = new StereotypeClient('Bearer ' + accessToken);
    return client.createTemplate(templateBody, contentType, false, templateType, templateName, templateDescription);
};
export const materializeTemplate = (accessToken, templateUrl, payload, contentType, options) => {
    const client = new StereotypeClient('Bearer ' + accessToken, { timeout: 10000 });
    const blockRels = (options === null || options === void 0 ? void 0 : options.blockRels) ? `${options.blockRels.join()},${xStereotypeRelBlacklist}` : xStereotypeRelBlacklist;
    const acceptPreference = (options === null || options === void 0 ? void 0 : options.acceptPreference) || xStereotypeAcceptPreference;
    client.setBlacklistHeader(blockRels);
    client.setAcceptPreferenceHeader(acceptPreference);
    (options === null || options === void 0 ? void 0 : options.allowRels) && client.setWhitelistHeader(options.allowRels.join());
    (options === null || options === void 0 ? void 0 : options.curies) && client.setCurieHeader(options.curies.join());
    if ((options === null || options === void 0 ? void 0 : options.maxDepth) || (options === null || options === void 0 ? void 0 : options.maxDepth) === 0) {
        client.setMaximumCrawlDepthHeader(options.maxDepth);
    }
    (options === null || options === void 0 ? void 0 : options.softErrors) && client.setCrawlerSoftErrors(options.softErrors.join());
    return client.materialize(templateUrl, payload, false, false, contentType);
};
//# sourceMappingURL=stereotype.api.js.map